<div class="card">
  <div class="icon-circle">
    <!-- Alert Icon SVG -->
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="56"
      height="56"
      viewBox="0 0 56 56"
      fill="none"
    >
      <path
        d="M27.9997 4.66658C15.113 4.66658 4.66634 15.1133 4.66634 27.9999C4.66634 40.8866 15.113 51.3332 27.9997 51.3332C40.8863 51.3333 51.333 40.8866 51.333 27.9999C51.333 15.1133 40.8863 4.66658 27.9997 4.66658Z"
        stroke="#FFA06A"
        stroke-width="4"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M28 18.6667L28 28"
        stroke="#FFA06A"
        stroke-width="4"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <circle cx="28" cy="36" r="2" fill="#FFA06A" />
    </svg>
  </div>
  <div>
    <!-- Expired header-->
    <div class="header">
      {{ heading }}
    </div>
    <!-- Expired description -->
    <div class="description">
      {{ description }}
    </div>
  </div>
</div>
